module.exports = __webpack_public_path__ + "static/key-niffelheim-bf921e5526d96383c8fb2597bbfbd84d.webp";